import React from 'react'
import HeaderHome from '../../components/HeaderHome'
import FooterHome from '../../components/FooterHome'
import { TabelaPrecos } from '../../components/TabelaPrecos'
import { TabelaPrecosHome } from '../../components/TabelaPrecosHome'


const HomePage = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh'
        }}>
            <HeaderHome />
            <div style={{ flex: 1, color: '#172554', fontSize: '1.5em', marginLeft:'1em' }}>
                <TabelaPrecosHome />
            </div>
            <FooterHome />
        </div>
    )
}

export default HomePage
